import styled from 'styled-components';

export const ChangelogsContainer = styled.div`
  position: relative;
  padding-bottom: 28px;
`;

export const ChangelogVersion = styled.div<{ $index: number }>`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  width: 150px;
  padding-top: ${props => props.$index === 0 ? '0' : '25px'};
  color: ${props => props.$index === 0 ? '#E0E0E0' : '#9E9E9E'};
`;

export const ChangelogLinesContainer = styled.div`
  display: flex;
  width: 55px;
  overflow: hidden;
`;

export const ChangelogDot = styled.div`
  width: 12px;
  height: 12px;
  background-color: #525252;
  border-radius: 100%;
  position: absolute;
  top: 6px;
  left: 138px;
`;

export const ChangelogContainer = styled.div`
  flex: 1;
  border-bottom: 2px solid #525252;
  padding: 12px;
`;

export const ChangelogTitle = styled.div<{ $index: number }>`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  padding-left: 25px;
  position: relative;
  top: ${props => props.$index === 0 ? '-25px' : '0'};
`;

export const ChangelogTime = styled.span`
  color: #9e9e9e !important;
  font-weight: 500;
  font-size: 16px;
`;

export const ChangelogBadgesContainer = styled.div`
  display: flex;
`;

export const Badge = styled.div`
  padding: 4px 14px 4px 14px;
  border-radius: 16px;
  color: black;
  font-size: 16px;
  font-family: 400;
  margin-right: 12px;
`;

export const BadgeYellow = styled(Badge)`
  background-color: #ffbb38;
  border: 1px solid #ffcf74;
`;

export const BadgeGreen = styled(Badge)`
  background-color: #18a957;
  border: 1px solid #5dc389;
  color: white;
`;

export const BadgeBlue = styled(Badge)`
  background-color: #4f72cc;
  border: 1px solid #6b8de4;
  color: white;
`;

export const ChangelogSeparator = styled.div<{ $index: number }>`
  width: 55px;
  border-right: ${props => props.$index === 0 ? '2px dashed #525252' : '2px solid #525252'};
  border-top: ${props => props.$index === 0 ? '2px dashed #525252' : 'none'};
  position: ${props => props.$index === 0 ? 'relative' : 'static'};
  top: ${props => props.$index === 0 ? '11px' : 'auto'};
`;

export const ChangelogULList = styled.ul<{ $index: number }>`
  margin-top: ${props => props.$index === 0 ? '0' : '16px'};
`;

export const ChangelogItemContainer = styled.div`
  display: flex;
`;
